import { c as _c } from "react/compiler-runtime";
import { SUBJECT_VIEW_MODES, VIEW_MODES_CONFIG } from "@components/view-mode-selector/view-mode-selector-constants";
import { ToggleGroup } from "@flat-ui";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { dataViewModeSelector } from "@store/ui/ui-selector";
import { setDataViewMode } from "@store/ui/ui-slice";
import { DataViewEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * @returns the icon-only toggle of a view mode, named by its tooltip
 * @param viewMode the view mode
 */
function toToggleItem(viewMode) {
  const {
    tooltipTitle,
    iconComponent: Icon
  } = VIEW_MODES_CONFIG[viewMode];
  return {
    value: viewMode,
    label: "",
    tooltip: tooltipTitle,
    icon: <Icon sx={{
      // Hides background rectangles/utility layers within the Map icon from the Design System.
      // The SVG loader adds a unique prefix (e.g., 'map-large_svg__') to classes,
      // so we use a partial attribute selector to target them.
      "& [class*='map-large-1']": {
        display: "none"
      }
    }} />
  };
}

/**
 * Selector to choose the data view mode for a given subject (groups, projects, etc.)
 */
export function ViewModeSelector(t0) {
  const $ = _c(14);
  const {
    subject
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const dispatch = useAppDispatch();
  const subjectsViewMode = useAppSelector(dataViewModeSelector);
  const currentViewMode = subjectsViewMode[subject];
  const viewModes = SUBJECT_VIEW_MODES[subject];
  let t1;
  if ($[0] !== dispatch || $[1] !== subject || $[2] !== trackEvent) {
    t1 = function updateDataViewMode(viewMode) {
      trackEvent({
        name: DataViewEvents.changeViewMode,
        props: {
          viewMode
        }
      });
      dispatch(setDataViewMode({
        subject,
        viewMode
      }));
    };
    $[0] = dispatch;
    $[1] = subject;
    $[2] = trackEvent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateDataViewMode = t1;
  let t2;
  if ($[4] !== viewModes) {
    t2 = viewModes.map(toToggleItem);
    $[4] = viewModes;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== currentViewMode || $[7] !== updateDataViewMode) {
    t3 = viewMode_0 => {
      if (viewMode_0 !== currentViewMode) {
        updateDataViewMode(viewMode_0);
      }
    };
    $[6] = currentViewMode;
    $[7] = updateDataViewMode;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      mr: 1.5
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== currentViewMode || $[11] !== t2 || $[12] !== t3) {
    t5 = <ToggleGroup items={t2} value={currentViewMode} onChange={t3} sxGroup={t4} />;
    $[10] = currentViewMode;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}